import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

interface IconProps {
  icon: IconProp
  size?: string
  color?: string
}

const IconWrapper = styled.div<Pick<IconProps, 'size' | 'color'>>`
  color: ${(props) => props.color || '#333'};
  font-size: ${(props) => props.size || '24px'};
  transition: color 0.2s ease;
  cursor: pointer;
  margin-right: 0.5rem;

  &:hover {
    color: ${(props) => props.color || '#ff6347'};
  }
`

const Icon: React.FC<IconProps> = ({ icon, size, color }) => {
  return (
    <IconWrapper size={size} color={color}>
      <FontAwesomeIcon icon={icon} />
    </IconWrapper>
  )
}

export default Icon
